export default __webpack_public_path__ + "static/media/iRead_2022.a878906f.jpg";